import {
  DATA_SOURCE_NAME_FIELD,
  DATA_SOURCE_VENDOR_FIELD,
  EVENT_CATEGORY_FIELD,
  EVENT_TIME_FIELD,
  EVENT_TYPE_FIELD,
  SEVERITY_FIELD,
} from './constants';
import { FIELD_TYPE, SchemaFields } from './types';

export const DEFAULT_FIELDS: SchemaFields = {
  [DATA_SOURCE_NAME_FIELD]: {
    label: 'Datasource',
    type: FIELD_TYPE.DATA_SOURCE,
    width: 190,
  },
  [DATA_SOURCE_VENDOR_FIELD]: {
    label: 'Vendor',
    type: FIELD_TYPE.DATA_SOURCE_VENDOR,
    width: 150,
  },
  [EVENT_TIME_FIELD]: {
    label: 'Event Time',
    type: FIELD_TYPE.TIMESTAMP,
    description: 'Time event was created',
    width: 150,
  },
  [EVENT_CATEGORY_FIELD]: {
    label: 'Event Category',
    type: FIELD_TYPE.EVENT_CATEGORY,
    description: 'Category of the event',
    values: [
      'command_script',
      'cross_process',
      'dns',
      'file',
      'firmware',
      'indicators',
      'ip',
      'logins',
      'module',
      'named_pipe',
      'process',
      'registry',
      'scheduled_task',
      'threat_intelligence_indicators',
      'url',
    ],
    icon: {
      command_script: 'command-scripts',
      cross_process: 'cross-process',
      dns: 'dns_ic',
      file: 'files_ic',
      firmware: 'firmware',
      indicators: 'indicators_ic',
      ip: 'mgmt-ranger_network',
      logins: 'logins-ic',
      module: 'dll_ic',
      process: 'processes_ic',
      registry: 'registry_key_ic',
      scheduled_task: 'scheduled_tasks_ic',
      threat_intelligence_indicators: 'forensics-detected-by',
      unknown: 'ranger_unknown',
      url: 'urls_ic',
    },
  },
  [EVENT_TYPE_FIELD]: {
    type: FIELD_TYPE.EVENT_TYPE,
    label: 'Event Type',
    description: 'Type of the Event',
    relatedFields: ['event.category'],
    width: 190,
  },
  [SEVERITY_FIELD]: {
    label: 'Event Severity',
    type: FIELD_TYPE.NUMBER,
    description: 'Severity on the event',
  },
};
